import React from 'react';
import { DefaultBsComponent } from '../../types/module';

const typeColor = (type: string) => {
  switch (type) {
    case 'Warning':
      return 'bg-coral-21 border-coral-101';
    case 'Remember':
      return 'bg-yellow-21 border-yellow-101';
    default:
      return 'bg-blue-21 border-blue-101';
  }
};

export interface BoxProps extends DefaultBsComponent {
  type: 'Info' | 'Warning' | 'Remember';
  title: string;
  content: string;
}

export const Box = ({ type, title, as: Component = 'div' }: BoxProps) => (
  <div
    className={`Box ${typeColor(
      type,
    )} rounded-lg p-6 border-l-8 my-8`}
  >
    <Component className="text-xl leading-snug">{title}</Component>
  </div>
);
